//package/index.js
import PTable from "@/package-admin/p-table/index.js";
import PInput from "@/package-admin/p-input/index.js";
import PTag from "@/package-admin/p-tag/index.js";
import PTooltip from "@/package-admin/p-tooltip/index.js";
import PScrollbar from "@/package-admin/p-scrollbar/index.js";
import { PSelect, POption, POptionGroup, PSelectDropdown } from "@/package-admin/p-select";
import PTableColumn from "@/package-admin/p-table/Table-column/index";
import PTestButton from "@/package-admin/p-test-button/index.vue";

// 所有组件
const components = [
    PTable,
    PInput,
    PTag,
    PTooltip,
    PScrollbar,
    PSelect,
    POption,
    POptionGroup,
    PSelectDropdown,
    PTableColumn,
    PTestButton
];

// install 方法
const install = function (Vue) {
    components.forEach((com) => {
        Vue.component(com.name, com);
    });
};

// 支持按需引入
export { PTable, PInput, PTag, PTooltip, PScrollbar, PSelect, POption, POptionGroup, PSelectDropdown, PTableColumn, PTestButton };

// 支持全局引入
export default install;
